import { render, staticRenderFns } from "./UserTabs.vue?vue&type=template&id=db02cab6&scoped=true&"
import script from "./UserTabs.vue?vue&type=script&lang=js&"
export * from "./UserTabs.vue?vue&type=script&lang=js&"
import style0 from "./UserTabs.vue?vue&type=style&index=0&id=db02cab6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db02cab6",
  null
  
)

export default component.exports